/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Sent_TitleInputs */



/**
* | output |
* | --- |
* | "Check your inbox" |
*
* @param {Login_Sent_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_sent_title = /** @type {((inputs?: Login_Sent_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Sent_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Kijk in je inbox")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Consultez votre boîte mail")
	return /** @type {LocalizedString} */ ("Check your inbox")
});